// src/components/OutreachList.js
import React, { useState } from 'react';
import { useOutreach }   from '../context/OutreachContext';
import { useSchedule }   from '../context/ScheduleContext';
import './OutreachList.styles.scss';

export default function OutreachList() {
  const {
    calls,
    emails,
    visits,
    removeCall,
    removeEmail,
    removeVisit
  } = useOutreach();

  const { addItem: addToSchedule } = useSchedule();

  // which ids are currently expanded?
  const [expandedIds, setExpandedIds] = useState([]);
  // for scheduling date picker
  const [schedulingId, setSchedulingId] = useState(null);
  const [scheduleDate, setScheduleDate] = useState(
    new Date().toISOString().slice(0,10)
  );

  const toggleExpand = fid =>
    setExpandedIds(prev =>
      prev.includes(fid)
        ? prev.filter(id => id !== fid)
        : [...prev, fid]
    );

  const renderList = (list, type) => {
    // pick correct remove function
    const removeFn =
      type === 'Calls'  ? removeCall
      : type === 'Emails' ? removeEmail
      : removeVisit;

    return (
      <div className={`outreach-section outreach-${type.toLowerCase()}`}>
        <h2>{type}</h2>
        {list.length === 0
          ? <p className="empty">No {type.toLowerCase()}</p>
          : list.map(item => {
              // your context stores either {fid,attributes} or raw feature.
              const fid = item.fid ?? item.attributes.FID;
              const a   = item.attributes;

              const expanded = expandedIds.includes(fid);
              return (
                <div key={fid} className="outreach-item">
                  <div
                    className="outreach-header"
                    onClick={() => toggleExpand(fid)}
                  >
                    <span>{a.Name}</span>
                    <span className="indicator">
                      {expanded ? '▾' : '▸'}
                    </span>
                  </div>

                  {expanded && (
                    <div className="outreach-details">
                      <p><strong>Phone:</strong> {a.Phone || 'N/A'}</p>
                      <p><strong>Email:</strong> {a.EMail || 'N/A'}</p>
                      <p>
                        <strong>Website:</strong>{' '}
                        {a.WebAddres
                          ? <a href={a.WebAddres} target="_blank" rel="noopener noreferrer">
                              {a.WebAddres}
                            </a>
                          : 'N/A'}
                      </p>
                      <p>
                        <strong>Address:</strong> {a.StreetNo} {a.StreetName}
                        {a.UnitNo ? `, Unit ${a.UnitNo}` : ''}, {a.PostalCode}
                      </p>
                      <p><strong>Ward:</strong> {a.Ward}</p>

                      <div className="expanded-actions">
                        {/* 1) Add to Today */}
                        <button onClick={() => {
                          const today = new Date().toISOString().slice(0,10);
                          addToSchedule(today, item);
                          removeFn(item);
                        }}>
                          Add to Today
                        </button>

                        {/* 2) Schedule (opens date picker) */}
                        <button onClick={() => {
                          setSchedulingId(fid);
                          setScheduleDate(new Date().toISOString().slice(0,10));
                        }}>
                          Schedule
                        </button>

                        {/* 3) Remove permanently */}
                        <button onClick={() => removeFn(item)}>
                          Remove
                        </button>
                      </div>

                      {/* date-picker + confirm/cancel */}
                      {schedulingId === fid && (
                        <div style={{ marginTop: 8 }}>
                          <input
                            type="date"
                            value={scheduleDate}
                            onChange={e => setScheduleDate(e.target.value)}
                          />
                          <button onClick={() => {
                            addToSchedule(scheduleDate, item);
                            removeFn(item);
                            setSchedulingId(null);
                          }}>
                            ✔️
                          </button>
                          <button onClick={() => setSchedulingId(null)}>
                            ✖️
                          </button>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              );
            })}
      </div>
    );
  };

  return (
    <div className="outreach-list">
      {renderList(calls,  'Calls')}
      {renderList(emails, 'Emails')}
      {renderList(visits, 'Visits')}
    </div>
  );
}
